module.exports = __webpack_public_path__ + "static/cassio-975ad5cb7e776cf573e0faaba22ab95a.jpeg";